import React from 'react';
import AgentDashboard from './AgentDashboard';

const PWMSDashboard: React.FC = () => {
  const agentConfig = {
    id: 'pwms-support',
    displayName: 'PWMS',
    icon: '/assets/logos/aldo-no-back.png',
    color: '#f59e0b',
    description: 'Production Workforce Management System support',
    hasTestResults: true
  };

  return <AgentDashboard agentConfig={agentConfig} />;
};

export default PWMSDashboard;